"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInput = void 0;
var react_1 = __importDefault(require("react"));
var _1 = require(".");
var TextInput = function (_a) {
    var placeholder = _a.placeholder, value = _a.value, autofocus = _a.autofocus, onChange = _a.onChange, label = _a.label, rows = _a.rows, name = _a.name;
    var textArea = (react_1.default.createElement("textarea", { className: "border border-grey leading-normal px-2 py-1 text-grey-darkest focus:border-blue\n shadow-inner", name: name, rows: rows, placeholder: placeholder, value: value, autoFocus: autofocus, onChange: onChange }));
    return label ? react_1.default.createElement(_1.Label, { text: label }, textArea) : textArea;
};
exports.TextInput = TextInput;
